import React, { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import Pagination from "@mui/material/Pagination";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import UnfoldMoreRoundedIcon from "@mui/icons-material/UnfoldMoreRounded";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

const Table = (props) => {
    const [allLabels, setAllLabels] = useState([]);

    useEffect(() => {
        if (props.rows && props.rows.length > 0) {
            setAllLabels(Object.keys(props.rows[0]));
        }
    }, [props.rows]);

    const handleSort = (name, order, sort) => {
        if (!sort) return;

        props?.handleSort({
            column: name,
            order: order === "desc" ? "asc" : "desc",
        });
    };

    const hasRows = props.rows && props.rows.length > 0;

    return (
        <div className={classes.wrapper}>
            <div className={classes.scroller}>
                <table className={classes.tableDesign}>
                    <thead>
                        <tr>
                            {props.columns.map((c, i) => (
                                <th
                                    key={i}
                                    className={[
                                        c.sort ? classes.sortable : "",
                                        c.align === "right" ? classes.right : "",
                                        c.align === "center" ? classes.center : "",
                                        c.nowrap ? classes.nowrap : "",
                                    ].filter(Boolean).join(" ") || undefined}
                                    title={c.hint || undefined}
                                >
                                    <div
                                        className={classes.th_content}
                                        onClick={() => handleSort(c.name, props.sort?.order, c.sort)}
                                    >
                                        <span>{c.label}</span>
                                        {c.sort ? (
                                            props.sort?.column === c.name ? (
                                                props.sort?.order === "asc" ? (
                                                    <ArrowUpwardIcon className={classes.sort_active} />
                                                ) : (
                                                    <ArrowDownwardIcon className={classes.sort_active} />
                                                )
                                            ) : (
                                                <UnfoldMoreRoundedIcon className={classes.sort_idle} />
                                            )
                                        ) : null}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {hasRows ? (
                            props.rows.map((r, i) => (
                                <tr key={i}>
                                    {allLabels.map((a, j) => {
                                        // Column order mirrors key order in the row objects, so
                                        // alignment can be read straight off the column at j.
                                        const col = props.columns?.[j];
                                        const align = col?.align;
                                        return (
                                            <td
                                                key={j}
                                                className={[
                                                    align === "right" ? classes.right : "",
                                                    align === "center" ? classes.center : "",
                                                    col?.nowrap ? classes.nowrap : "",
                                                ].filter(Boolean).join(" ") || undefined}
                                            >
                                                {r[a]}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))
                        ) : (
                            <tr className={classes.empty_row}>
                                <td colSpan={props.columns?.length || 1}>
                                    <div className={classes.empty}>
                                        <InboxOutlinedIcon />
                                        <p className={classes.empty_title}>No records found</p>
                                        <p className={classes.empty_hint}>
                                            Try adjusting the search or filters for this view.
                                        </p>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {props.hidePagination && !props?.count ? null : (
                <div className={classes.pagination}>
                    <div className={classes.count}>
                        {props?.count ? (
                            <span>
                                <strong>{props.count}</strong> record
                                {props.count === 1 ? "" : "s"}
                            </span>
                        ) : null}
                    </div>

                    {props.hidePagination ? null : (
                        <Pagination
                            count={props.total}
                            shape="rounded"
                            page={props.pageNo}
                            onChange={props.handlePage}
                            siblingCount={1}
                            size="small"
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default Table;
